import { createFileRoute } from '@tanstack/react-router'
import { CreateComplianceRulePage } from '../../../components/CreateComplianceRulePage'
import { PermissionDeniedState } from '../../../components/PermissionDeniedState'
import { useCan } from '../../../contexts/PermissionsContext'

export const Route = createFileRoute('/$org/compliance-rules/create')({
  component: CreateComplianceRule,
})

function CreateComplianceRule() {
  // The section's `read` guard let this caller in; creating needs `write`, so
  // a deep link to /create must not hand them a form that can only 403.
  const canWrite = useCan('compliance.write')
  if (!canWrite) return <PermissionDeniedState permission="compliance.write" />
  return <CreateComplianceRulePage />
}
